'use client';
import { useContext, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { AppContext, PageType } from 'context/AppContext';
import { useQueryParam } from 'hooks/useQueryParam';
import { isMobile } from 'utils/detect';
import { AdAllianceLib, SiteType } from './adAllianceLib';

export const AdAlliance = () => {
  const {
    pageType,
    pageMetaData: { adZone, keywords },
  } = useContext(AppContext);

  const pathname = usePathname();
  const device = useQueryParam('device')?.toLowerCase();
  const currentAdZone = pathname === '/' ? 'homepage' : adZone;

  const isGujAdPreview = !!useQueryParam('gujAd');
  const [isMoltenTopScriptLoaded, setIsMoltenTopScriptLoaded] = useState(false);

  const MOLTEN_SCRIPT_TOP = 'https://www.rtl.de/mbundle/top_v2.js';
  const MOLTEN_SCRIPT_BOTTOM = 'https://www.rtl.de/mbundle/bottom_v2.js';

  const MOLTEN_SCRIPT_PREVIEW_TOP = 'https://adctrl.emsmobile.de/molten/preview/rtl.de/MoltenBundle.js';
  const MOLTEN_SCRIPT_PREVIEW_BOTTOM = 'https://adctrl.emsmobile.de/molten/preview/rtl.de/MoltenBundle.bottom.js';

  useEffect(() => {
    const getSiteType = () =>
      ({ android: SiteType.Android, ios: SiteType.iOS })[device ?? ''] ??
      (isMobile() ? SiteType.Mobile : SiteType.Desktop);

    AdAllianceLib.initialize({
      siteType: getSiteType(),
      adZone: currentAdZone,
      keywords: keywords,
      pageType: pageType === 'article' ? PageType.Article : PageType.Overview,
    });
  }, [device, keywords, pageType, currentAdZone]);

  return (
    <>
      <Script
        id="molten-top"
        strategy="afterInteractive"
        src={isGujAdPreview ? MOLTEN_SCRIPT_PREVIEW_TOP : MOLTEN_SCRIPT_TOP}
        onReady={() => setIsMoltenTopScriptLoaded(true)}
        async
      />

      {isMoltenTopScriptLoaded && (
        <Script
          id="molten-bottom"
          strategy="afterInteractive"
          src={isGujAdPreview ? MOLTEN_SCRIPT_PREVIEW_BOTTOM : MOLTEN_SCRIPT_BOTTOM}
        />
      )}
    </>
  );
};
